const sitemap = require('./sitemap.xml');
import './styles/index.scss';

// Import the required DOM management plugins first
import "bootstrap/js/dist/dom/data";
import "bootstrap/js/dist/dom/event-handler";
import "bootstrap/js/dist/dom/manipulator";
import "bootstrap/js/dist/dom/selector-engine";
import "bootstrap/js/dist/base-component";

// Then your specific components
// import {Modal} from "bootstrap/js/dist/modal";
// window.modal = Modal;

 import "bootstrap/js/dist/offcanvas";

 import "bootstrap/js/dist/collapse";

 import "bootstrap/js/dist/carousel";
 import "bootstrap/js/dist/alert";

//import { Modal, Offcanvas, Collapse, Carousel, Alert } from 'bootstrap';

//import "./js/sidenav";
import "./js/scroll-to-top";
//import "./js/tracking";

import "./js/cookieconsent-config";

import sosLogo from "./images/sos_pare-brise_plus_logo.png"

 window.dataLayer = window.dataLayer || [];

 
